<template>
  <v-card v-resize="onResize" class="fill-height">
    
    <v-tabs
      hide-slider
      grow
      show-arrows
      class="fill-height"
      :color="focused ? 'accent' : ''"
      :dark="focused"
      v-model="tab.href"
    >
      <v-tab
        v-for="item in itemsMenu"
        :key="item.href"
        :href="'#' + item.href"
        @click.native="checkTab(item)"
        :disabled="item.disabled.status"
        :title="item.title"
      >
        <v-icon
          size="24"
          :color="tab.href === item.href
            ? 'secondary'
            : item.disabled.status
              ? 'grey'
              : focused
                ? 'white'
                : 'grey darken-2'"
        >{{ item.icone }}</v-icon>
      </v-tab>
      <!-- <v-tabs-items style="height: calc(100% - 48px)"> -->
        <v-tab-item
          v-for="item in itemsMenu"
          :key="item.href"
          :value="item.href"
          class="fill-height"
          :ref="`tab-item-${item.href}`"
          v-bar
        >
          <v-card
            flat
            height="100%"
            width="calc(100% - 20px)"
            class="contentFicheVisiteur"
            :class="{'cobrowsing--container': item.href == 'mirroring' || item.href == 'cobrowsing'}">
            <component
              v-if="tab.href === item.href && item.show"
              :is="item.component"
              class="fill-height tab-item__component"

              :datasVisiteur="datasVisiteur"
              :datasPupitreVisiteur="datasPupitreVisiteur"
              
              :params="'visId=' + datasVisiteur.visiteurID"
              :toolbar="true"
              :navigation="true"
              chatHeight="100%"
              numChatsTotal="0"
              type="chatting"
              colorChatAgent="grey lighten-1"
              colorChatVisiteur="grey"
              
              :hauteurDiv.sync="hauteurDiv"
              @closeCobrowsing="annuleCobrowsing(); tab = itemsMenu[0]"

              @closeDialog="tab = itemsMenu[0]"
              openOnMounted
              
              @put="msg => $emit('update:msg', msg)"
              @send="msg => $emit('sendMsg', msg)"
            ></component>
          </v-card>
        </v-tab-item>
      <!-- </v-tabs-items> -->
    </v-tabs>
    <!-- dialog reconnexion -->
    <v-dialog v-model="dialogDemandeCobrowsing" persistent max-width="290">
      <v-card>
        <v-card-title class="primary white--text subheading">{{$t('titleAskCobrowsing')}}</v-card-title>
        <v-card-text>
          {{ txtDemandeCobrowsing }}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn 
            class="blue--text darken-1" flat @click="annuleCobrowsing(); tab = itemsMenu[0]">{{txtBtCobrowsing}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import { mapGetters, mapState, mapActions, mapMutations } from 'vuex'
import Cobrowsing from '../watcheebox/cobrowsing.js'
import WzFicheInfosVisiteur from './WzFicheInfosVisiteur'
import WzFicheLeadVisiteur from './WzFicheLeadVisiteur'
import WzFicheBiblioPhrases from './WzFicheBiblioPhrases'
import WzHistoChats from '../watcheezy/WzHistoChats'
import WzHistoBot from '../watcheezy/WzHistoBot'
import WzCobrowsingClient from './WzCobrowsingClient'
import WzDialogTransfertChat from './WzDialogTransfertChat'
import WzDialogBannishVisitor from './WzDialogBannishVisitor'
import WzIframeExtension from './WzIframeExtension'
import _ from 'lodash'
import { LEVEL } from '../../constants.js'
export default {
  components: {
    WzCobrowsingClient,
    WzFicheInfosVisiteur,
    WzFicheBiblioPhrases,
    WzFicheLeadVisiteur,
    WzHistoChats,
    WzHistoBot
  },
  data () {
    return {
      hauteurDiv: 0,
      dialogDemandeCobrowsing: false,
      txtBtCobrowsing: this.$t('cancel'),
      txtDemandeCobrowsing: '',
      /**
       * @type {Object}
       * Permet de gérer les événements liés au cobrowsing
       */
      cobrowsing: null,
      /**
       * Indique le tab sélectionné
       */
      tab: { href: '' }
    }
  },

  props: ['datasVisiteur', 'datasPupitreVisiteur', 'placesPupitre'],

  methods: {
    ...mapActions('_Notifier', ['NEW_NOTIF']),
    ...mapMutations('_StoreWatcheeBox', [
      'SET_STATUS_COBROWSING',
      'SET_VISITEURS'
    ]),

    // ----------------------------------------------------------------------------
    // l'agent annule la demande de cobrowsing
    // ----------------------------------------------------------------------------
    annuleCobrowsing () {
      console.log('-> annuleCobrowsing')
      this.dialogDemandeCobrowsing = false
      this.SET_STATUS_COBROWSING({
        placePupitre: this.datasVisiteur.placePupitre,
        status: false
      })
      var agentSocketID = this.WATCHEEBOX_STATE.mySocketID
      // envois de la demande de cobrowsing au visiteur
      this.cobrowsing = new Cobrowsing()
      if (this.cobrowsing) {
        this.cobrowsing.demandeCobrowsing({
          active: false,
          agentSocketID: agentSocketID,
          datasAgent: this.user,
          datasVisiteur: this.datasVisiteur
        })
      }
    },

    // ----------------------------------------------------------------------------
    // l'agent envoit une demande cobrowsing au visiteur
    // ----------------------------------------------------------------------------
    checkCobrowsingAutorisation () {
      console.log('-> check Cobrowsing autorisation')
      if (!this.datasVisiteur.reponseCobrowsing) {
        // pas de session cobrowsing, on lance la demande
        this.sendDemandeCobrowsing()
      }
    },

    // ----------------------------------------------------------------------------
    // l'agent envoit une demande cobrowsing au visiteur
    // ----------------------------------------------------------------------------
    sendDemandeCobrowsing () {
      console.log('-> sendDemandeCobrowsing')
      this.dialogDemandeCobrowsing = true
      this.txtBtCobrowsing = this.$t('cancel')
      // phrase par defaut
      this.txtDemandeCobrowsing = this.$t('contentAskCobrowsing')
      var agentSocketID = this.WATCHEEBOX_STATE.mySocketID
      this.SET_STATUS_COBROWSING({
        placePupitre: this.datasVisiteur.placePupitre,
        status: false
      })
      // envois de la demande de cobrowsing au visiteur
      this.cobrowsing = new Cobrowsing()
      this.cobrowsing.demandeCobrowsing({
        active: true,
        agentSocketID: agentSocketID,
        datasAgent: this.user,
        datasVisiteur: this.datasVisiteur,
        placePupitre: this.datasVisiteur.placePupitre
      })
    },

    onResize () {
      this.hauteurDiv = this.$el.offsetHeight - 100
    },

    /**
     * Affiche une info si le tab n'est pas clickable
     */
    checkTab (item) {
      // Vérifie que l'onglet est actif
      if (item.disabled.status) {
        this.NEW_NOTIF({
          message: this.$t(item.disabled.raison),
          context: 'error'
        })
      }
    },

    /**
     * Sélection de l'onglet par défaut :
     * ne peut être le bannissement
     * par défaut il devient le premier
     */
    selectTab () {
      let tab = this.itemsMenu.find(
        t => t.href === this.datasVisiteur.menuSelected
      )
      if (tab && tab.href !== 'banish') {
        if (tab.href === 'transfertChat') {
          if (this.transfertStatusEmission.status === 'wait') {
            this.tab = tab
          } else {
            this.tab = this.itemsMenu[0]
          }
        } else {
          this.tab = tab
        }
      } else {
        this.tab = this.itemsMenu[0]
      }
    }
  },

  watch: {
    'datasVisiteur.reponseCobrowsing': function (val, oldVal) {
      console.log('checkReponseCobrowsing', val)
      if (val) {
        this.dialogDemandeCobrowsing = false
      } else {
        this.txtDemandeCobrowsing = this.$t('visitorNoCobrowsing')
        this.txtBtCobrowsing = this.$t('close')
      }
    },

    'transfertStatusEmission.status': function (val, oldVal) {
      if (val === 'wait' && this.transfertStatusEmission.datas.chatSession === this.datasVisiteur.visiteurID) {
        this.tab.href = 'transfertChat'
      }
    },

    placesPupitre () {
      this.onResize()
    },

    'tab.href': function (newVal, oldVal) {
      let tab = this.itemsMenu.find(t => t.href === newVal)
      if (!tab) {
        return
      }
      if (!tab.scroll) {
        const ref = this.$refs[`tab-item-${tab.href}`][0]
        this.$vuebar.destroyScrollbar(ref.$el)
      }
      let visiteur = _.cloneDeep(this.datasVisiteur)
      // Indique l'état du cobrowsing au store, selon l'onglet choisi
      let statusCobrowsing = false
      if (tab.href === 'mirroring' || tab.href === 'cobrowsing') {
        statusCobrowsing = true
      }
      if (tab.href === 'cobrowsing') {
        this.checkCobrowsingAutorisation()
      } else {
        visiteur.reponseCobrowsing = false
        // this.annuleCobrowsing()
      }
      this.SET_STATUS_COBROWSING({
        placePupitre: this.datasVisiteur.placePupitre,
        status: statusCobrowsing
      })
      visiteur.menuSelected = newVal
      this.SET_VISITEURS(visiteur)
    },

    'datasVisiteur.visiteurID': function (newVal, oldval) {
      this.selectTab()
    }
  },

  mounted () {
    this.onResize()
  },

  created () {
    this.selectTab()
    if (this.transfertStatusEmission.status === 'wait' && this.transfertStatusEmission.datas.chatSession === this.datasVisiteur.visiteurID) {
      this.tab.href = 'transfertChat'
    }
    // this.annuleCobrowsing() // envois une annulation de cobrowsing au visiteur en cas de rechargement de l'agent pour effacer la demande chez le visiteur
  },

  computed: {
    ...mapState('_StoreWatcheeBox', [
      'listeAllVisiteurs',
      'lastMessage',
      'transfertStatusEmission',
      'mySocketID',
      'demandeCobrowsing',
      'focusPupitre',
      'agentsArray'
    ]),
    ...mapGetters('_StoreWatcheeBox', ['WATCHEEBOX_STATE']),
    ...mapState('_Sites', ['sites']),
    ...mapState('_User', ['entLevel']),
    ...mapGetters('_Sites', ['GET_SITE_BY_ID']),
    ...mapGetters('_User', ['user', 'level']),

    /**
     * Vérifie la possibilité de lancer du mirroring ou du cobrowsing
     */
    check () {
      // console.log('this.datasVisiteur', this.datasVisiteur)
      let site = this.GET_SITE_BY_ID(this.datasVisiteur.siteID)
      // console.log('site', site)
      if (!site) {
        return { status: true, raison: 'error' }
      }
      let checked = {
        status: false,
        raison: ''
      }
      // if (site.LIC_COBROWSING_ACTIVATED === '0') {
      //   checked = { status: true, raison: 'warningCobrowsingDisabled' }
      // } else if (
      if (
        this.datasVisiteur.network &&
        this.datasVisiteur.network !== undefined
      ) {
        checked = { status: true, raison: 'networkVisitor' }
      } else if (!this.datasVisiteur.socketID) {
        checked = { status: true, raison: 'visitorNoSocket' }
        // } else if (!this.mirroringMenuActif) {
        // checked = { status: true, raison: 'inUse' }
      } else {
        if (this.datasPupitreVisiteur.visiteurDatas) {
          // marche pas si pas https
          if (
            this.datasPupitreVisiteur.visiteurDatas.pagesFocus &&
            this.datasPupitreVisiteur.visiteurDatas.pagesFocus.indexOf(
              'http://'
            ) === 1
          ) {
            // marche pas si pas https
            checked = { status: true, raison: 'notHttps' }
          } else {
            checked = { status: false }
          }
        } else {
          checked = { status: true, raison: 'noDataVisiteur' }
        }
      }
      // console.log('return check', checked)
      return { site: site, ...checked }
    },

    checkReponseCobrowsing () {
      // return this.datasVisiteur.reponseCobrowsing
    },

    /**
     * check que le cobrowsing est bien possible
     * pour ce visiteur et pour le site sur lequel il navigue
     */
    checkMirroring () {
      let checked = this.check
      // console.log('checked mirroring', this.check)
      if (checked.site.DSK_MIRRORING === '0') {
        checked = { status: true, raison: 'warningMirroringSettingDisabled' }
      }
      return checked
    },

    /**
     * check que le cobrowsing est bien possible
     * pour ce visiteur et pour le site sur lequel il navigue
     */
    checkCobrowsing () {
      let checked = this.check
      // console.log('checked cobrowsing', this.check)
      if (checked.site.DSK_COBROWSING === '0') {
        checked = { status: true, raison: 'warningMirroringSettingDisabled' }
      }
      return checked
    },

    /**
     * check que le transfert est bien possible
     * pour ce visiteur et pour le site sur lequel il navigue
     */
    checkTransfert () {
      let checked = this.check
      if (this.entLevel === '10' || this.entLevel === '1') {
        // checked = { status: true, raison: 'warningMirroringSettingDisabled' }
        checked = { status: true, raison: this.$tc('notLevelRights', this.level.title, {count: this.level.title}) }
      }
      return checked
    },

    checkIframeExtension () {
      if (this.level.rights !== LEVEL.ENTREPRISE) {
        return { status: true, raison: this.$tc('notLevelRights', this.level.title, {count: this.level.title}) }
      }
      let site = this.GET_SITE_BY_ID(this.datasVisiteur.siteID)
      if (!site || site.DSK_EXTENSION_ONOFF !== '1') {
        return { status: true, raison: 'error' }
      }
      return false
    },

    /**
     * Construction du menu de la fiche visiteur
     */
    itemsMenu () {
      let menus = []
      /**
       * indique le contexte par défaut :
       * - agent pas sur la page monitoring
       * - visiteur pas sur autre network
       */
      const defaultContext = !this.monitoringRoute && !this.fromAnotherNetwork
      let visitorCard = {
        title: this.$t('visitorCard'),
        href: 'visitorCard',
        component: WzFicheInfosVisiteur,
        icone: 'account_box',
        disabled: false,
        show: true,
        scroll: true
      }
      let conversationHistory = {
        title: this.$t('conversationHistory'),
        href: 'conversationHistory',
        component: WzHistoChats,
        icone: 'forum',
        disabled: false,
        show: true,
        scroll: true
      }
      let botHistory = {
        title: this.$t('botHistory'),
        href: 'botHistory',
        component: WzHistoBot,
        icone: 'adb',
        disabled: false,
        show: true,
        scroll: true
      }
      let mirroring = !this.fromAnotherNetwork && {
        title: 'Mirroring',
        href: 'mirroring',
        component: WzCobrowsingClient,
        icone: 'phonelink',
        disabled: this.checkMirroring,
        show: this.$socket && this.$socket.connected,
        scroll: false
      }
      let visitorEditing = defaultContext && {
        title: this.$t('visitorEditing'),
        href: 'visitorEditing',
        component: WzFicheLeadVisiteur,
        icone: 'create',
        disabled: false,
        show: true,
        scroll: true
      }
      let quickSentences = !this.monitoringRoute && {
        title: this.$t('quickSentences'),
        href: 'quickSentences',
        component: WzFicheBiblioPhrases,
        icone: 'collections_bookmark',
        disabled: false,
        show: true,
        scroll: true
      }
      let cobrowsing = defaultContext && {
        title: 'Cobrowsing',
        href: 'cobrowsing',
        component: WzCobrowsingClient,
        icone: 'open_in_browser',
        disabled: this.checkCobrowsing,
        show:
          this.$socket &&
          this.$socket.connected &&
          !this.dialogDemandeCobrowsing,
        scroll: false
      }
      let transfertChat = defaultContext && {
        title: _.upperFirst(this.$t('toTransfer')),
        href: 'transfertChat',
        component: WzDialogTransfertChat,
        icone: 'transfer_within_a_station',
        disabled: this.checkTransfert,
        show: this.$socket && this.$socket.connected,
        scroll: true
      }
      let banish = defaultContext && {
        title: _.upperFirst(this.$t('banish')),
        href: 'banish',
        component: WzDialogBannishVisitor,
        icone: 'block',
        disabled: false,
        show: true,
        scroll: true
      }
      let iframeExtension = defaultContext && {
        title: _.upperFirst(this.$t('extension')),
        href: 'extension',
        component: WzIframeExtension,
        icone: 'extension',
        disabled: this.checkIframeExtension,
        show: true,
        scroll: false
      }
      // Ajout des menus
      visitorCard && menus.push(visitorCard)
      conversationHistory && menus.push(conversationHistory)
      botHistory && menus.push(botHistory)
      mirroring && menus.push(mirroring)
      visitorEditing && menus.splice(1, 0, visitorEditing)
      quickSentences && menus.splice(2, 0, quickSentences)
      cobrowsing && menus.push(cobrowsing)
      transfertChat && menus.push(transfertChat)
      banish && menus.push(banish)
      iframeExtension && menus.push(iframeExtension)
      return menus
    },
    /**
     * Indique si le composant est focus
     */
    focused () {
      return this.focusPupitre.focusSessionID === this.datasVisiteur.visiteurID
    },
    /**
     * Indique si le visiteur provient d'un autre network
     * Facebook par exemple
     */
    fromAnotherNetwork () {
      return (
        this.datasVisiteur.network && this.datasVisiteur.network.trim().length
      )
    },
    monitoringRoute () {
      return this.$route.fullPath === '/trafic/monitoring'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/watcheebox/WzContentInfosVisiteur.vue